// @ts-nocheck
import { useParams, Navigate } from "react-router-dom"
import { EditPostForm } from "@/components/post/EditPostForm"
import { useAuth } from "@/components/layout/AuthProvider"

export default function EditPostPage() {
  const { id } = useParams<{ id: string }>()
  const { supabaseUser } = useAuth()
  if (!supabaseUser || !id) return <Navigate to="/feed" replace />
  return (
    <div className="container-narrow py-4">
      <h1 className="font-bold text-xl mb-4">Edit Post</h1>
      <EditPostForm postId={id} userId={supabaseUser.id} />
    </div>
  )
}